import axios from "axios";
import config from "../Config";

const apiClient = axios.create({
  baseURL: `${config.apiBaseUrl.replace(/\/+$/, "")}/`,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

const getStoredValue = (key) =>
  sessionStorage.getItem(key) || localStorage.getItem(key);

apiClient.interceptors.request.use(
  (requestConfig) => {
    const token = getStoredValue("newToken");
    const userId = getStoredValue("userId");
    const pincode = getStoredValue("pincode");
    const city = getStoredValue("city");

    if (token) {
      requestConfig.headers.Authorization = `Bearer ${token}`;
      // requestConfig.headers["x-access-token"] = token;
      // requestConfig.headers.Authorization = `Bearer ${token}`;
    }

    if (userId) {
      requestConfig.headers.userId = userId;
    }

    if (pincode) {
      requestConfig.headers.pincode = pincode;
    }

    if (city) {
      requestConfig.headers.city = city;
    }

    return requestConfig;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

export default apiClient;
